import { render, staticRenderFns } from "./Active.vue?vue&type=template&id=12d3e51a&scoped=true"
import script from "./Active.vue?vue&type=script&lang=js"
export * from "./Active.vue?vue&type=script&lang=js"
import style0 from "./Active.vue?vue&type=style&index=0&id=12d3e51a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d3e51a",
  null
  
)

export default component.exports